import React, { useRef, useState } from 'react';
import Breadcrumb from '../../components/Breadcrumb';
import { HoneyPot, FormNote } from '../../components/FormParts';
import { formValues, submitInquiry } from '../../lib/api/forms';
import { useSiteSettings } from '../../lib/api/settings';
import { useCollections } from '../../lib/api/collections';
import SocialBlock from '../../components/SocialBlock';

import shapeImg from '../../assets/img/contact/shape-2-1.png';

const ContactMain = () => {
  const { contact } = useSiteSettings();
  // Department contacts come from the back office (People > Departments). Nothing is shown until a department has an email or phone.
  const { departments } = useCollections('departments');
  const withContact = (departments || []).filter((d) => d.email || d.phone);
  const formRef = useRef();

  const [state, setState] = useState({ status: 'idle', message: '' });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setState({ status: 'sending', message: '' });
    try {
      await submitInquiry({ ...formValues(formRef.current), source: 'contact' });
      formRef.current.reset();
      setState({ status: 'success', message: 'Thank you. Your message has been sent. We will reply soon.' });
    } catch (err) {
      setState({ status: 'error', message: err.message });
    }
  };

  return (
    <main>
      <Breadcrumb title="Contact Us" subTitle="Contact Us" />

      <div className="it-contact__area pt-120 pb-120">
        <div className="container">
          <div className="it-contact__wrap fix z-index-3 p-relative">
            <div className="it-contact__shape-1 d-none d-xl-block">
              <img src={shapeImg} alt="" />
            </div>
            <div className="row align-items-end">
              <div className="col-xl-7">
                <div className="it-contact__right-box">
                  <div className="it-contact__section-box pb-20">
                    <h4 className="it-contact__title pb-15">Get in Touch</h4>
                    <p>
                      Questions about a degree or a short course? Write to us{' '}
                      <br />
                      or call.
                    </p>
                  </div>
                  <div className="it-contact__content mb-55">
                    <ul>
                      <li>
                        <div className="it-contact__list d-flex align-items-start">
                          <div className="it-contact__icon">
                            <span>
                              <i className="fa-solid fa-location-dot"></i>
                            </span>
                          </div>
                          <div className="it-contact__text">
                            <span>Address</span>
                            <a
                              target="_blank"
                              rel="noreferrer"
                              href="https://www.google.com/maps/search/SANASA+Campus+Paragammana+Kegalle"
                            >
                              {contact.address}
                            </a>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="it-contact__list d-flex align-items-start">
                          <div className="it-contact__icon">
                            <span>
                              <i className="fa-solid fa-graduation-cap"></i>
                            </span>
                          </div>
                          <div className="it-contact__text">
                            <span>Admissions</span>
                            <a href={contact.admissionsPhoneHref}>
                              {contact.admissionsPhone}
                            </a>
                            <a href={`mailto:${contact.admissionsEmail}`}>
                              {contact.admissionsEmail}
                            </a>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="it-contact__list d-flex align-items-start">
                          <div className="it-contact__icon">
                            <span>
                              <i className="fa-solid fa-phone phone"></i>
                            </span>
                          </div>
                          <div className="it-contact__text">
                            <span>General And Training</span>
                            <a href={contact.generalPhoneHref}>
                              {contact.generalPhone}
                            </a>
                            <a href={`mailto:${contact.email}`}>
                              {contact.email}
                            </a>
                            <a href={contact.cccsPhoneHref}>
                              CCCS: {contact.cccsPhone}
                            </a>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div className="it-contact__bottom-box d-flex align-items-center justify-content-between">
                    <div className="it-contact__scrool smooth">
                      <a href="#">
                        <i className="fa-solid fa-arrow-down"></i>Write To Us
                      </a>
                    </div>
                    <div className="it-footer-social">
                      <a href={contact.facebook} target="_blank" rel="noreferrer">
                        <i className="fa-brands fa-facebook-f"></i>
                      </a>
                      <a href={contact.instagram} target="_blank" rel="noreferrer">
                        <i className="fa-brands fa-instagram"></i>
                      </a>
                      <a href={contact.youtube} target="_blank" rel="noreferrer">
                        <i className="fa-brands fa-youtube"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-5">
                <div className="it-contact__form-box">
                  <form ref={formRef} onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-12 mb-25">
                        <div className="it-contact-input-box">
                          <label>Name*</label>
                          <input type="text" name="name" placeholder="Name" required maxLength={120} />
                        </div>
                      </div>
                      <div className="col-12 mb-25">
                        <div className="it-contact-input-box">
                          <label>Email Address*</label>
                          <input type="email" name="email" placeholder="Email" required maxLength={200} />
                        </div>
                      </div>
                      <div className="col-12 mb-25">
                        <div className="it-contact-input-box">
                          <label>Phone*</label>
                          <input type="tel" name="phone" placeholder="Phone" required maxLength={30} />
                        </div>
                      </div>
                      <div className="col-12 mb-25">
                        <div className="it-contact-input-box">
                          <label>Subject*</label>
                          <input type="text" name="subject" placeholder="Subject" required maxLength={200} />
                        </div>
                      </div>
                      <div className="col-12 mb-25">
                        <div className="it-contact-textarea-box">
                          <label>Message*</label>
                          <textarea name="message" placeholder="Message" required maxLength={4000}></textarea>
                        </div>
                      </div>
                    </div>
                    <HoneyPot />
                    <button
                      type="submit"
                      className="ed-btn-square radius purple-4"
                      disabled={state.status === 'sending'}
                    >
                      <span>{state.status === 'sending' ? 'Sending...' : 'Send Message'}</span>
                    </button>
                    <FormNote status={state.status}>{state.message}</FormNote>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="sc-contact-extra pb-120">
        <div className="container">
          <div className="sc-map">
            <iframe
              title="Map of SANASA Campus"
              src={`https://www.google.com/maps?q=${encodeURIComponent(contact.addressFull || contact.address)}&output=embed`}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            ></iframe>
          </div>
          {withContact.length > 0 && (
            <div className="sc-depts">
              <h4>Department contacts</h4>
              <div className="sc-dept-grid">
                {withContact.map((d) => (
                  <div key={d.id} className="sc-dept">
                    <h5>{d.name}</h5>
                    {d.phone && <a href={`tel:${d.phone.replace(/[^0-9+]/g, '')}`}><i className="fa-light fa-phone"></i> {d.phone}</a>}
                    {d.email && <a href={`mailto:${d.email}`}><i className="fa-light fa-envelope"></i> {d.email}</a>}
                  </div>
                ))}
              </div>
            </div>
          )}
          <SocialBlock />
        </div>
      </div>
    </main>
  );
};

export default ContactMain;
